<template>
  <div
    v-if="card_vars.length"
    class="vars-list">
    <div
      v-for="val in card_vars"
      :key="val.formulaCode"
      class="pa-0 text-start h7-text">
      {{ val.formulaCode }} - "{{ val.title }}"
    </div>
  </div>
</template>
<script>
import { criteriasMixin } from 'mixins'

export default {
  name: 'criteriaCardVars',
  mixins: [ criteriasMixin ] ,
  props: {
    card: {
      type: Object,
      required: true
    },
  },
  computed: {
    card_vars() {
      return (this.card.reducedPriceCriterias || this.card?.criterias || [])?.filter(el => {
        if ( this.checkUnusedCode(el, this.card?.criterias, this.card?.reducedPriceFormula || this.card?.formula, this.card ) ) {
          return false
        }
        return !!el.formulaCode
      })
    }
  },
}
</script>
